// CourseList의 filterButton
export const COURSE_FILTER_ALL = 1;
export const COURSE_FILTER_ON_GOING = 2;
export const COURSE_FILTER_EXPIRED = 3;

// CourseList의 모바일 nav_tab
export const NAV_TAB_NUM_COURSE = 1;
export const NAV_TAB_NUM_INFO = 2;

export const GENDER_NUM_MALE = 1;
export const GENDER_NUM_FEMALE = 2;

// CourseList의 한 번에 보여줄 course 수
export const COURSE_SHOW_NUM = 8;

// 아이디, 비밀번호찾기 옵션
export const FIND_ACCOUNT_OPTIONS = [
    {
        title: "아이디 찾기",
        path: "/account/find-email",
    },
    {
        title: "비밀번호 찾기",
        path: "/account/find-password",
    },
];

export const COURSE_INIT_SET = {
    id: null,
    title: null,
    document_url: null,
};

export const ATTENDANCE_OBJ_INIT_SET = {
    this_month: null,
    total: null,
    total_attendance_rate: null,
};

export const LOGIN_USER_INFO_INIT_SET = {
    account: {
        value: undefined, // 최초에 undefinde로 선언 -> CustomInput에서 undefinde가 아니면 focus유지(최초렌더시 focus방지)
        error_msg: null,
    },
    password: {
        value: undefined, // 최초에 undefinde로 선언 -> CustomInput에서 undefinde가 아니면 focus유지(최초렌더시 focus방지)
        error_msg: null,
    },
    keep_login: false,
};

export const UPDATE_PW_INFO_INIT_SET = {
    prev_pw: {
        value: undefined,
        error_msg: null,
    },
    new_pw: {
        value: undefined,
        error_msg: null,
    },
    check_new_pw: {
        value: undefined,
        error_msg: null,
    },
};

export const FIND_EMAIL_INIT_SET = {
    name: {
        value: undefined,
        error_msg: null,
    },
    birth: {
        value: undefined,
        error_msg: null,
    },
    phone: {
        value: undefined,
        error_msg: null,
    },
};
